"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingAcceptStatusEnum = void 0;
/** Статус подтверждения участия в митинге */
var MeetingAcceptStatusEnum;
(function (MeetingAcceptStatusEnum) {
  /** подтверждение не требутся */
  MeetingAcceptStatusEnum[MeetingAcceptStatusEnum["not_required"] = 0] = "not_required";
  /** требуется подтверждение и пока нет подтверждения */
  MeetingAcceptStatusEnum[MeetingAcceptStatusEnum["required"] = 1] = "required";
  /** участие подтверждено */
  MeetingAcceptStatusEnum[MeetingAcceptStatusEnum["accepted"] = 2] = "accepted";
  /** участие отклонено */
  MeetingAcceptStatusEnum[MeetingAcceptStatusEnum["declined"] = 3] = "declined";
})(MeetingAcceptStatusEnum = exports.MeetingAcceptStatusEnum || (exports.MeetingAcceptStatusEnum = {}));
